// OrderBucketDrawer.js

import React, { useState, useEffect } from "react"
import { Drawer, List, Avatar, Button, Typography, Space, Select, Form } from "antd"
import { DeleteOutlined, CopyrightCircleOutlined, ShoppingCartOutlined } from "@ant-design/icons"

const { Text, Title } = Typography
const { Option } = Select

export default function OrderBucketDrawer({
  visible,
  onClose,
  items,
  onRemoveItem,
  onPlaceOrder,
  isPlacingOrder,
  machines, // Receive machines data
  machinesLoading, // Receive loading state for machines
}) {
  // 1. Add state to hold the selected machine
  const [selectedMachine, setSelectedMachine] = useState(null)

  const totalSum = items.reduce((sum, item) => sum + (item.price || 0), 0)

  // 2. Reset the selected machine when the drawer is closed
  useEffect(() => {
    if (!visible) {
      setSelectedMachine(null)
    }
  }, [visible])

  return (
    <Drawer
      title={
        <Space>
          <ShoppingCartOutlined />
          Order Bucket
        </Space>
      }
      placement="right"
      onClose={onClose}
      open={visible}
      width={400}
      footer={
        <div style={{ textAlign: "right" }}>
          <div style={{ marginBottom: "16px" }}>
            <Title level={4} style={{ margin: 0 }}>
              Total: €{totalSum.toFixed(2)}
            </Title>
          </div>
          <Space>
            <Button onClick={onClose} disabled={isPlacingOrder}>
              Continue Selecting
            </Button>
            <Button
              type="primary"
              // 3. Pass the selected machine to the onPlaceOrder function
              onClick={() => onPlaceOrder(selectedMachine)}
              loading={isPlacingOrder}
              disabled={items.length === 0}>
              Place Order ({items.length} items)
            </Button>
          </Space>
        </div>
      }>
      {items.length === 0 ? (
        <Text>Your order bucket is empty. Add some rolls from the table!</Text>
      ) : (
        <>
          {/* 4. Add the Select dropdown for machines */}
          <Form layout="vertical">
            <Form.Item label="Destination Machine" required>
              <Select
                placeholder="Select a machine"
                style={{ width: "100%" }}
                value={selectedMachine}
                onChange={(value) => setSelectedMachine(value)}
                loading={machinesLoading}
                disabled={isPlacingOrder}>
                {machines?.map((machine) => (
                  <Option key={machine.id} value={machine.machine}>
                    {machine.machine}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>

          <List
            itemLayout="horizontal"
            dataSource={items}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <Button
                    type="text"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => onRemoveItem(item.id)}
                    disabled={isPlacingOrder}
                    aria-label={`Remove roll ${item.barcode || item.id}`}
                  />,
                ]}
                extra={<Text strong>€{(item.price || 0).toFixed(2)}</Text>}>
                <List.Item.Meta
                  avatar={<Avatar icon={<CopyrightCircleOutlined />} />}
                  title={<Text strong>{item.material?.material || "Unknown Material"}</Text>}
                  description={
                    <Space direction="vertical" size="small">
                      <Text>Meters: {item.remainingMeters}m</Text>
                      <Text>Width: {item.rollWidth}mm</Text>
                    </Space>
                  }
                />
              </List.Item>
            )}
          />
        </>
      )}
    </Drawer>
  )
}
